define('ResetPassword.Model', [
    'Backbone',
    'jQuery',
    'Utils'
], function (
    Backbone,
    jQuery,
    Utils
) {
    'use strict';

    var serviceUrl = Utils.getAbsoluteUrl(
        getExtensionAssetsPath('Modules/ResetPassword/SuiteScript2/ResetPassword.Service.ss'),
        true
    );

    return Backbone.Model.extend({
        validateToken: function validateToken(identity) {
            return jQuery.ajax({
                url: serviceUrl,
                type: 'GET',
                dataType: 'json',
                data: identity
            });
        },

        resetPassword: function resetPassword(data) {
            return jQuery.ajax({
                url: serviceUrl,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data)
            });
        }
    });
});
